module.exports = __webpack_public_path__ + "static/media/carousel2.e88882e9.jpg";